import React from 'react'
import { EmptyContainer, Container } from './styles'
import { TimelineGeneral } from '../timeline'
import { HumanBodyTimeline } from '~/components/shared'
import { Loader, NotFound } from '~/components/shared/medicalViews'

interface IProps {
  contentType: 'timeline' | 'humanBody' // TODO: Resolver duplicação de tipagem (EViewOptions)
  isLoading: boolean
  hasData: boolean
}

export const GeneralMainPanel = ({ contentType, isLoading, hasData }: IProps): JSX.Element => {
  // TODO: Analisar e tentar utilizar EViewOptions nas comparações abaixo
  const contentTypeIsHumanBody = contentType === 'humanBody'
  const contentTypeIsTimeline = contentType === 'timeline'

  if (isLoading) {
    return (
      <EmptyContainer>
        <Loader />
      </EmptyContainer>
    )
  }

  if (hasData && contentTypeIsHumanBody) {
    return (
      <Container>
        <HumanBodyTimeline />
      </Container>
    )
  }

  if (hasData && contentTypeIsTimeline) {
    return (
      <Container>
        <TimelineGeneral />
      </Container>
    )
  }

  return (
    <EmptyContainer>
      <NotFound />
    </EmptyContainer>
  )
}
